import InternalAvatar from './avatar';
import Group from './group';
export { Group };
var Avatar = InternalAvatar;
Avatar.Group = Group;
export default Avatar;